import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/authSlice";
import Modal from "./Modal";

const LogoutConfirmationModal = ({
  isOpen,
  onClose,
  message = "Are you sure you want to logout?",
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleConfirmLogout = () => {
    onClose?.();
    dispatch(logout());
    navigate("/login");
  };

  if (!isOpen) return null;

  return createPortal(
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Logout"
      confirmText="Logout"
      confirmVariant="danger"
      cancelText="Cancel"
      onConfirm={handleConfirmLogout}
      size="md"
      align="center"
      zIndexClassName="z-[60]"
      showCancel
      showCloseButton
    >
      <p className="text-sm leading-6 text-slate-600 dark:text-slate-400">
        {message}
      </p>
    </Modal>,
    document.body,
  );
};

export default LogoutConfirmationModal;
